// @flow

import {type RecordFactory, type RecordInstance, Map, Record} from 'immutable';

import type {ResponseType} from 'app/utils/redux_v2';

import {
  type KBActionType,
  RECEIVE_KB_DETAIL,
  REQUEST_KBS_DASHBOARD_LIST,
} from '../actions';

type KnowledgebaseStateShape = {
  byId: Map<string, Map<string, any>>,
  queries: Map<string, ResponseType<string>>,
  dashboard: {
    currentFilters: Map<string, string>,
  },
};

const KnowledgebaseStateFactory: RecordFactory<KnowledgebaseStateShape> =
  Record({
    byId: Map(),
    queries: Map(),
    dashboard: Map({
      currentFilters: Map(),
    }),
  });

export type RecordOfKnowledgebaseState =
  RecordInstance<KnowledgebaseStateShape>;

export function knowledgebaseReducer(
  state: RecordOfKnowledgebaseState = KnowledgebaseStateFactory(),
  action: KBActionType
): any {
  switch (action.type) {
    case RECEIVE_KB_DETAIL: {
      const kb = Map(action.kb);
      return state.setIn(['byId', action.kb.id.toString()], kb);
    }

    case REQUEST_KBS_DASHBOARD_LIST:
      return state.setIn(
        ['dashboard', 'currentFilters'],
        Map(action.currentFilters)
      );

    default:
      return state;
  }
}
